import React, { Component } from 'react'
import EvaluationFormHeader from './components/Header';
import EvaluationQuestionList from './components/QuestionList';
import Header from 'components/Header';
import '../../../Evaluations/scenes/Form/evaluationform.less';
import config from 'root/../config';
import ProceduresFormContext from '../../components/context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faSave } from '@fortawesome/free-solid-svg-icons/faSave';
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash';
import evaluationsConfig from '../../moduleConfig';
import UIComponent from 'components/UiComponent';
import MsgBox from 'sis_ui/modules/notifications';
import AppContext from 'components/appContext';
import dataService from 'services/dataService';
import authService from 'services/authService';
import AccessDenied from 'components/AccessDenied';
import { withRouter } from 'components/Routing';
import {useTranslation,withTranslation} from "react-i18next";

const sceneCode = "PROCEDURES_EVALUATION_FORM";

let EvaluationButtons = ({formDetails, compact, getUserForm, router}) => {
    const { navigate} = router;

    let setButtonsState = ()=>{};
    const {t} = useTranslation();

    const _deleteEvaluationFormCallback = (result) => {
        if(result.body) {
            MsgBox.drawMessage(result.body.STATUS, result.body.MESSAGE);
            if(result.body.STATUS == "success"){
                window.localStorage.setItem('evaluations-list-igonre-cache',true);
                navigate('/' + evaluationsConfig.map.PROCEDURE_EVALUATIONS_LIST.path);
            } 
        }else{
            MsgBox.drawMessage('error', t("lbl.ERROR_PROCESSING_REQUEST","There was an error processing your request"));
        };
        setButtonsState("active");
    }
    const _saveEvaluationFormCallBack = (result) => {
        if(result) {
            MsgBox.drawMessage(result.body.STATUS, result.body.MESSAGE);
        }else{
            MsgBox.drawMessage('error', t("lbl.ERROR_PROCESSING_REQUEST","There was an error processing your request"))
        };

        setButtonsState("active");
    }

    const _submitEvaluationFormCallback = (setError) => {
        return (result)=>{
            if(result.body) {
                if(result.body.STATUS == "success"){
                    getUserForm();
                    MsgBox.drawMessage(result.body.STATUS, result.body.MESSAGE);
                    window.localStorage.setItem('evaluations-list-igonre-cache',true);
                }
    
                if(result.body.STATUS == "error"){
                    result.body.MESSAGE.forEach((item, i) => {
                        if(item.TAG == ""){
                            MsgBox.drawMessage(result.body.STATUS, result.body.MESSAGE);
                        }else{
                            setError(item.TAG, item.MESSAGE);
                        }
                    })
                }
            }else {
                MsgBox.drawMessage('error', t("lbl.ERROR_PROCESSING_REQUEST","There was an error processing your request"));
            };
            setButtonsState("active");
        }
    }

    return(
        <UIComponent component="smart-form-consumer">
            {({ setError, values, submitForm }) => (
                <UIComponent
                    component="button-group"
                    id="procedure-form-buttons"
                    class={`btn-group ${formDetails.STATUS_CODE == "DRAFT" ? "btn-group--draft": ""}`}
                    getPublicData={(data) => {
                        setButtonsState = data.setButtonGroupState;
                    }}
                    displayType="dropdown"
                    dropUp
                    compact={compact}
                    groupClass="bg-blue color-white btn__no-border"
                >
                    <UIComponent
                        id="saveForm"
                        name="saveForm"
                        className="color-blue btn__no-border save-btn-active"
                        component="smart-button"
                        title={t("lbl.SAVE","Save")}
                        iconComponent={<FontAwesomeIcon icon={faSave} size={"1x"} />}
                        onClick={(event) => {
                            submitForm({ action: config.apiAppUrl + evaluationsConfig.APIs.saveEvaluation, method: "POST" }, _saveEvaluationFormCallBack);
                        }}
                        triggeredText={t("lbl.SAVING","Saving...")}
                    > {t("lbl.SAVE","Save")} {formDetails.STATUS_CODE == "DRAFT" ? t("lbl.AS_DRAFT","as Draft") : ""}</UIComponent>
                    {formDetails.STATUS_CODE == "DRAFT" && 
                         <UIComponent
                         id="submitOnBehalf"
                         name="submitOnBehalf "
                         className="color-green btn__no-border submit-btn-active"
                         component="smart-button"
                         title={t("lbl.SUBMIT","Submit")}
                         iconComponent={<FontAwesomeIcon icon={faCheck} size={"1x"} />}
                         confirmation={{
                             TITLE : t("lbl.SUBMIT_AS_EVALUATOR","Submit as Evaluator"),
                             BODY  : t("lbl.ASSESMENT_SUBMITED_BY_EVALUATOR","This assessment is being submitted by, or on behalf of the evaluator."),
                             BUTTONS : [
                                 {
                                     ON_CLICK: (event) => {
                                         event.preventDefault();
                                         submitForm({ action: config.apiAppUrl + evaluationsConfig.APIs.submitEvaluation, method: "POST" }, _submitEvaluationFormCallback(setError, values));
                                     },
                                 }
                             ],
                         }}
                         showConfirmation={true}
                         triggeredText={t("lbl.SUBMITTING","Submitting...")}
                     > {t("lbl.SUBMIT_AS_EVALUATOR","Submit as Evaluator")}</UIComponent>                       
                    }
                    {formDetails.STATUS_CODE == "DRAFT" ? 
                        <UIComponent
                            id="sendForm"
                            name="sendForm "
                            className="color-green btn__no-border submit-btn-active"
                            component="smart-button"
                            title={t("lbl.SEND","Send")}
                            iconComponent={<FontAwesomeIcon icon={faCheck} size={"1x"} />}
                            confirmation={{
                                TITLE : t("lbl.SEND_EVALUATION","Send Evaluation"),
                                BUTTONS : [
                                    {
                                        ON_CLICK: (event) => {
                                            event.preventDefault();
                                            submitForm({ action: config.apiAppUrl + evaluationsConfig.APIs.sendEvaluation, method: "POST" }, _submitEvaluationFormCallback(setError, values));
                                        },
                                    }
                                ],
                            }}
                            showConfirmation={true}
                            triggeredText={t("lbl.SENDING","Sending...")}
                        > {t("lbl.SEND_TO_EVALUATOR","Send to Evaluator")} </UIComponent>
                        
                    :
                        <UIComponent
                            id="submitForm"
                            name="submitForm "
                            className="color-green btn__no-border submit-btn-active"
                            component="smart-button"
                            title={t("lbl.SUBMIT","Submit")}
                            iconComponent={<FontAwesomeIcon icon={faCheck} size={"1x"} />}
                            confirmation={{
                                TITLE : t("lbl.SUBMIT_EVALUATION","Submit Evaluation"),
                                BUTTONS : [
                                    {
                                        ON_CLICK: (event) => {
                                            event.preventDefault();
                                            submitForm({ action: config.apiAppUrl + evaluationsConfig.APIs.submitEvaluation, method: "POST" }, _submitEvaluationFormCallback(setError, values));
                                        },
                                    }
                                ],
                            }}
                            showConfirmation={true}
                            triggeredText={t("lbl.SUBMITTING","Submitting...")}
                        > {t("lbl.SUBMIT","Submit")} </UIComponent>
                    }
                    {formDetails.STATUS_CODE == "DRAFT" && 
                        <UIComponent
                            id="deleteForm"
                            name="deleteForm "
                            className="color-red-light btn__no-border delete-btn-active"
                            component="smart-button"
                            title={t("lbl.SEND","Send")}
                            iconComponent={<FontAwesomeIcon icon={faTrash} size={"1x"} />}
                            confirmation={{
                                TITLE : t("lbl.DELETE_EVALUATION","Delete Evaluation"),
                                BUTTONS : [
                                    {
                                        ON_CLICK: (event) => {
                                            event.preventDefault();
                                            submitForm(
                                                { 
                                                    action: config.apiAppUrl + evaluationsConfig.APIs.deleteEvaluation, 
                                                    method: "POST",
                                                    values: {
                                                        EVALUATION_ID: formDetails.EVALUATION_ID,
                                                        USER_FORM_ID: formDetails.USER_FORM_ID,
                                                    }
                                                }, 
                                                _deleteEvaluationFormCallback
                                            );
                                        },
                                    }
                                ],
                            }}
                            showConfirmation={true}
                            triggeredText={t("lbl.DELETING","Deleting...")}
                        > {t("lbl.DELETE","Delete")} </UIComponent>
                    }
                </UIComponent>
            )}
        </UIComponent>
    )
}

EvaluationButtons = withRouter(EvaluationButtons);
class EvaluationForm extends Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);

        this.state = {
            userFormID: null,
            questions: null,
            questionsIds: [],
            answers : [],
            details : null,
            placeholders : null,
            scrolled: false,
            focusedQuestionId: null,
            readOnlyForm: true,
            restricted: false,
        }
        this.headerHight = 145;
    }

    componentDidMount() {
        this.context.setCurrentScene(sceneCode);
        this._getUserForm();
    }

    _getUserForm(){
        this.setState({
            readOnlyForm: true
        }, ()=> {
            this.questionsReq = dataService.request({
                method: 'GET',
                url: config.apiAppUrl + evaluationsConfig.APIs.getEvaluationForm + '/' + this.props.router.params.id,
            })
                .accept('application/json');

            this.questionsReq.then((res) => {
                try {
                    let result = res.body;
                    this.setState({
                        userFormID: result.USER_FORM_ID,
                        questions: result.GROUPS,
                        questionsIds: result.GROUPS.reduce((acc, group) => {
                            let groupAcc = acc;
                            group.QUESTIONS.forEach(question => {
                                if (question.QUESTION_TYPE_CODE != "GENERAL_TEXT")
                                    groupAcc.push(question.QUESTION_CD);
                            });
                            return groupAcc;
                        }, []),
                        answers: result.ANSWERS,
                        details: result.DETAILS,
                        placeholders: result.PLACEHOLDERS,
                        readOnlyForm: ["COMPLETED", "DECLINED", "NOT_DISTRIBUTED"].indexOf(result.DETAILS.STATUS_CODE) >= 0 ? true : false || result.READ_ONLY
                    })
                } catch (e) {
                    MsgBox.drawMessage('error', this.props.t('lbl.INVALID_RESPONSE','Invalid response format'));
                }
            }).catch(e=>{
                if (e.response.statusCode == 403) {
                    this.setState({
                        restricted: true,
                    });
                }
            });
        });
    }

    componentWillUnmount (){
        if (this.questionsReq) {
            this.questionsReq.abort();
        }
    }

    _handleScroll(elem) {
        let resetScroll = true;

        if (elem.target.scrollTop == 0){
            resetScroll = true;
            this.setState({
                scrolled : false
            })
        }else if(resetScroll){
            resetScroll = false;
            this.setState({
                scrolled : true
            })
        }
    }

    _handleQuestionFocus = (targetId) => {
        this.setState({
            focusedQuestionId : targetId,
        });
    }

    _inReducer(accumulator,values){
        return {
            ...accumulator,
            [values.QUESTION_CD]: values.ANSWER_TEXT
        }
    }

    _outReducer(accumulator,values){
        let answers = [];
        if (accumulator.hasOwnProperty("answers")) {
            answers = JSON.parse(accumulator.answers);
        }

        let answer = this._updateAnswer(values[0], values[1]);
        if (answer) {
            answers = [
                ...answers,
                answer
            ];
        }
        return {
            user_form_id: this.state.userFormID,
            evaluation_id: this.state.details.EVALUATION_ID,
            auth_token: authService.getToken(),
            user_role: this.context.userDetails.CURRENT_ROLE,
            answers: JSON.stringify(answers),
        }
    }

    _updateAnswer(id,value) {
        return this.state.answers.reduce((acc,answer)=>{
            if (answer.QUESTION_CD == id) {
                return {
                    ...answer,
                    ANSWER_TEXT: value,
                };
            }
            return acc;
        },null);
    }

    render() {
        return (
            <ProceduresFormContext.Provider value={{ 
                questions: this.state.questions, 
                questionsIds: this.state.questionsIds, 
                details: this.state.details,
                placeholders: this.state.placeholders,
                focusedQuestionId: this.state.focusedQuestionId,
                readOnlyForm: this.state.readOnlyForm, 
                handleQuestionFocus: this._handleQuestionFocus.bind(this)
            }}>
                <UIComponent
                    component="smart-form"
                    values={this.state.answers}
                    inReducer={this._inReducer.bind(this)}
                    outReducer={this._outReducer.bind(this)}
                    class="evaluation-form-scene full-height--with-policy flex-column row"
                >
                    <Header {...this.props} />
                    {!this.state.restricted ?
                        <React.Fragment>
                            <EvaluationFormHeader headerHight={this.headerHight}/>
                            <div ref={this.formQuestions} className={`evaluation-form-questions col ${!this.state.readOnlyForm ? "pb-5" : ""}`} style={{paddingTop: this.state.questions != null ? this.headerHight -5 : 0}} onScroll={(event) => { this.context.updateScrollValue(event.target.scrollTop); this._handleScroll(event) }}>
                                <EvaluationQuestionList />
                                { this.state.details && !this.state.readOnlyForm &&
                                    <EvaluationButtons formDetails={this.state.details} compact={this.state.scrolled} getUserForm={this._getUserForm.bind(this)}/>
                                }
                            </div>
                        </React.Fragment>
                    :
                        <AccessDenied />
                    }
                </UIComponent>
            </ProceduresFormContext.Provider>
        )
    }
}

export default withRouter(withTranslation()(EvaluationForm));